import React, { useRef, useState } from 'react';
import HighCharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import "components/shared/chart/style.scss";
import { ToastNotification, ProgressLoader } from 'components/shared';
import $ from "jquery";
import applyExporting from 'highcharts/modules/exporting';
import applyOffline from 'highcharts/modules/offline-exporting';

export const Chart = (props) => {

    const { options, downloadReport } = props;

    applyExporting(HighCharts);
    applyOffline(HighCharts);

    return (
        <div className="mx-2">
            <HighchartsReact
                highcharts={HighCharts}
                options={options}
                size={{ height: "100px" }}
            />
            {downloadReport && <DownloadOptionTemplate downloadReport={(type) => downloadReport(type)} />}
        </div>
    );
}

export const DownloadOptionTemplate = (props) => {

    const { downloadReport } = props;
    const toastRef = useRef();

    const DownloadItemBtn = (props) => {
        const { color, icon, type } = props;
        const [loading, setLoading] = useState(false);

        $(() => {
            $('[data-toggle="tooltip"]').tooltip()
        })

        const handleDownloadClick = (type) => {
            setLoading(true);
            downloadReport(type).then((resp) => {
                toastRef?.current?.showToast({ type: "success", title: "Success", message: resp });
            }, error => {
                toastRef?.current?.showToast({ type: "error", title: "Error", message: error });
            }).finally(() => {
                setLoading(false);
            });
            $('[data-toggle="tooltip"]').tooltip('hide');
        }

        return <>
            {
                loading ?
                    <div className="sm-loader-container">
                        <ProgressLoader sm />
                    </div> : <span data-toggle="tooltip" title={`Download report in ${type} format`} className={`mr-2`} style={{ cursor: "pointer" }} onClick={() => handleDownloadClick(type)}>
                        {type}<i className={`${color} ${icon}`} />
                        <ToastNotification ref={toastRef} />
                    </span>
            }
        </>
    }

    return <pre className="d-flex" style={{ width: 'fit-content', float: 'right', overflow: 'inherit' }}>
        <DownloadItemBtn
            color="text-success"
            icon="bi bi-file-earmark-excel"
            type="xlsx" />

        <DownloadItemBtn
            color="text-danger"
            icon="bi bi-file-earmark-pdf"
            type="pdf" />
    </pre>
}